import { getFirstSelectedInvoiceStream } from '@/shared/components/registration/registrationHelpers';
import angular from 'angular';
import moment from 'moment';

angular
  .module('cxInvoicing')
  .controller('BatchUpdateRegistrationFieldDialogCtrl', [
    '$element',
    'close',
    'filters',
    'batchParams',
    'appUrls',
    '$http',
    'flySvc',
    'resourceFactorySvc',
    'resourceNameFilter',
    'checkFeature',
    batchUpdateRegistrationFieldDialogCtrl,
  ]);

function batchUpdateRegistrationFieldDialogCtrl(
  $element,
  close,
  filters,
  batchParams,
  appUrls,
  $http,
  flySvc,
  resourceFactorySvc,
  resourceNameFilter,
  checkFeature,
) {
  var vm = this;
  vm.saving = false;
  vm.relation = null;
  vm.invoiceStream = null;
  vm.resource = null;
  vm.showReferenceYear = checkFeature('ReferenceYear');
  vm.model = {
    field: '',
    boolValue: true,
    integerValue: null,
    relationId: null,
    invoiceStreamId: null,
    assignmentTemplateId: null,
    resourceId: null,
  };

  vm.save = function() {
    if (vm.model.field <= 0) return;

    if (parseInt(vm.model.field) === 5 && (!vm.model.relationId || !vm.model.invoiceStreamId))
      return;
    if (parseInt(vm.model.field) === 6 && !vm.model.assignmentTemplateId) return;
    if (parseInt(vm.model.field) === 7 && !vm.model.resourceId) return;
    if (parseInt(vm.model.field) === 8 && !vm.model.integerValue) return;

    if (vm.saving) return;
    const backgroundJob = [5, 6, 7].includes(parseInt(vm.model.field));
    vm.saving = true;
    $http
      .post(
        `${appUrls.api}/api/registration/BatchUpdateField`,
        {
          ...batchParams,
          ...vm.model,
          field: parseInt(vm.model.field),
        },
        { params: filters },
      )
      .then(
        function({ data }) {
          vm.saving = false;
          const count = data || 0;

          if (count > 0 && !backgroundJob)
            flySvc.success('msgBatchUpdateRegistrationsSuccess', { count });
          if (count > 0 && backgroundJob)
            flySvc.info('msgRegistrationsWillBeModifiedInTheBackground');
          $element.modal('hide');
          close(
            {
              count,
              ...vm.model,
            },
            500,
          );
        },
        function(error) {
          vm.saving = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
  };
  vm.cancel = function() {
    close(null, 500);
  };

  vm.invoiceStreamChanged = function() {
    vm.model.invoiceStream =
      (vm.model.invoiceStreamId &&
        vm.relation &&
        vm.invoiceStreams &&
        vm.invoiceStreams.find(x => x.id === vm.invoiceStreamId)) ||
      null;
  };

  vm.relationChanged = function() {
    const relation = vm.relation;
    vm.model.relationId = relation?.id;

    if (relation && relation.id && !relation.invoiceStreams) {
      //Recent relation selected. Retrieve relation again with invoice streams
      return resourceFactorySvc
        .get('relation')
        .ids(null, [relation.id])
        .$promise.then(
          ([rel] = []) => {
            if (rel && rel.id && rel.invoiceStreamId) {
              vm.relation = rel;
              vm.relationChanged();
            } else {
              vm.relation = null;
              vm.relationChanged();
            }
          },
          error => {
            flySvc.error(error);
            vm.relation = null;
            vm.relationChanged();
          },
        );
    }
    
    vm.invoiceStream = getFirstSelectedInvoiceStream(relation);
    vm.model.invoiceStreamId = vm.invoiceStream?.id;
  };
  vm.resourceChanged = () => {
    vm.model.resourceId = vm.resource?.id;
  };
  vm.referenceYearChanged = (year ) => {
    vm.model.integerValue = year;
  };

  resourceFactorySvc.get('resource').reg({}, function(data) {
    var resources = data
      .filter(x => x.type !== 3 && x.type !== 4)
      .map(item => ({ ...item, label: resourceNameFilter(item), code: item.code || '' }));
    vm.resources = resources;
  });
}
